import { Link } from "react-router-dom";
import useDepartmentDoctors from "../hooks/useDepartmentDoctors";
import DoctorCard from "./DoctorCard";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { Check, Phone, Mail, MapPin, Users, Building,Clock, Activity, Zap, Microscope,ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import SEO from "../pages/SEO"
import { useAppointment } from "../context/AppointmentContext"
export default function OrthopaedicsPage() {
  const { open: openAppointment } = useAppointment();
  const doctors = useDepartmentDoctors("Orthopedics");


 const subspecialties = [
    {
      title: "Joint Replacement Surgery",
      description: "Total knee, hip, and shoulder replacements.",
      image: "https://mamshospitals.com/JointReplacementSurgery2.jpg",
    },
    {
      title: "Arthroscopy & Sports Medicine",
      description: "Minimally invasive procedures for ligament, cartilage, and sports injuries.",
      image: "https://mamshospitals.com/SportsMedicine2.jpg",
    },
    {
      title: "Trauma & Fracture Care",
      description: "Emergency fixation of fractures and accident injuries.",
      image: "https://mamshospitals.com/Trauma&FractureCare2.jpg",
    },
    {
      title: "Spine Surgery",
      description: "Treatment of disc prolapse, scoliosis, spinal stenosis & back pain.",
      image: "https://mamshospitals.com/SpineSurgery2.jpg",
    },
    {
      title: "Pediatric Orthopaedics",
      description: "Bone deformities, gait disorders & injury care in children.",
      image: "/PediatricOrthopaedics.jpg",
    },
    {
      title: "Pain Management & Rehabilitation",
      description: "Physiotherapy, mobility training & long-term recovery plans.",
      image: "https://mamshospitals.com/PainManagement&Rehabilitation2.jpg",
    },
  ];

  const treatments = [
    "Total Knee Replacement (TKR)",
    "Total Hip & Shoulder Replacement",
    "ACL / PCL Reconstruction",
    "Arthroscopy for Shoulder & Knee",
    "Fracture Fixation (Plates, Screws, Nails)",
    "Spine Decompression & Fusion Surgery",
    "Arthritis & Osteoporosis Management",
    "Sports Injury Treatment",
    "Orthopaedic Physiotherapy & Rehabilitation",
  ];

  const whyChoose = [
    {
      icon: Users,
      title: "Experienced Surgeons",
      description: "Orthopaedic surgeons with specialized expertise",
    },
    {
      icon: Building,
      title: "Modern Facilities",
      description: "Advanced orthopedic equipment and operation theatres",
    },
    {
      icon: Activity,
      title: "Rehabilitation Center",
      description: "Dedicated physiotherapy & rehabilitation facility",
    },
    {
      icon: Zap,
      title: "24x7 Emergency Care",
      description: "Round-the-clock trauma & fracture emergency services",
    },
    {
      icon: Microscope,
      title: "Minimally Invasive",
      description: "Advanced arthroscopic procedures for faster recovery",
    },
  ];
  const articles = [
    { title: "Common Causes of Knee Pain and When to See a Doctor", category: "Knee Health" },
    { title: "Rehabilitation After Joint Replacement Surgery", category: "Recovery" },
    { title: "How to Prevent Sports Injuries", category: "Sports Medicine" },
    { title: "Lifestyle Tips for Stronger Bones at Any Age", category: "Bone Health" },
  ];
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "MAMS Hospitals Orthopaedics Department",
    "url": "https://mamshospitals.com/orthopaedics",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "image": "https://mamshospitals.com/Orthopaedic.jpg",
    "description": "MAMS Hospitals provides advanced orthopaedic treatment in Hyderabad including joint replacement surgery, arthroscopy, fracture care, spine surgery, sports injury treatment, and rehabilitation services.",
    "medicalSpecialty": "Orthopedic",
    "telephone": "+91-7399999981",
    "priceRange": "$$",

    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },

    "availableService": [
      {
        "@type": "MedicalProcedure",
        "name": "Knee Replacement Surgery"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Hip Replacement Surgery"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Arthroscopy & Sports Injury Treatment"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Spine Surgery"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Fracture & Trauma Care"
      }
    ],

    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do you perform knee and hip replacement surgeries?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals specializes in advanced knee, hip, and shoulder replacement surgeries with modern surgical techniques."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide sports injury treatment?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we provide arthroscopy, ligament reconstruction, physiotherapy, and complete sports injury management."
        }
      },
      {
        "@type": "Question",
        "name": "Is physiotherapy available at the hospital?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals has an in-house physiotherapy and rehabilitation center for recovery and mobility improvement."
        }
      }
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Orthopaedics Department - MAMS Hospitals",
    "url": "https://mamshospitals.com/orthopaedics",
    "description": "Best orthopaedic hospital in Hyderabad offering joint replacement surgery, sports injury treatment, fracture care, spine surgery, and rehabilitation.",
    "keywords": [
      "Orthopaedic Hospital Hyderabad",
      "Best Orthopaedic Doctor Hyderabad",
      "Knee Replacement Hyderabad",
      "Hip Replacement Hyderabad",
      "Sports Injury Treatment Hyderabad",
      "Spine Surgery Hyderabad",
      "Orthopaedic Hospital Bachupally"
    ]
  }
];

  return (
    <>
    <SEO
      title="Best Orthopaedic Hospital in Hyderabad | Joint Replacement & Spine Care | MAMS Hospitals"
      description="MAMS Hospitals offers advanced orthopaedic treatment in Hyderabad including knee replacement, hip replacement, fracture care, sports injury treatment, spine surgery, and rehabilitation."
      keywords="orthopaedic hospital Hyderabad,
    best orthopaedic doctor Hyderabad,
    knee replacement Hyderabad,
    hip replacement Hyderabad,
    joint replacement surgery Hyderabad,
    sports injury treatment Hyderabad,
    fracture treatment Hyderabad,
    spine surgery Hyderabad,
    arthroscopy Hyderabad,
    orthopaedic surgeon Hyderabad,
    physiotherapy Hyderabad,
    orthopaedic hospital Bachupally,
    MAMS Hospitals Orthopaedics"
      schema={schema}
    />
    <div className="flex flex-col min-h-screen">

      {/* HERO SECTION */}
        <section className="relative bg-gradient-to-br from-teal-50 via-white to-blue-50 py-12 md:py-24">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                Best Orthopaedic Hospital in Hyderabad
              </div>
              <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
                Expert Bone & Joint Care for Pain-Free Movement
              </h1>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                Move pain-free with expert orthopaedic care at MAMS Hospitals — restoring strength, stability, and
                mobility through advanced treatments and compassionate care.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">

                <Button className="bg-teal-600 hover:bg-teal-700 text-white rounded-full px-8" size="lg" onClick={openAppointment}>
                    Book Appointment
                  </Button>

                <Link to="tel:+91-7399999981">
                  <Button
                    className="border-teal-600 text-teal-600 hover:bg-teal-50 rounded-full px-8"
                    variant="outline"
                    size="lg"
                  >
                    <Phone className="mr-2 h-5 w-5" />
                    Call Us
                  </Button>
                </Link>

              </div>
            </div>
            <div className="relative">
              <div className="absolute -top-4 -right-4 bg-teal-600 text-white p-6 rounded-2xl shadow-xl z-10">
                <div className="text-3xl font-bold">95%</div>
                <div className="text-sm">Success Rate</div>
              </div>
              <img
                src="/Orthopaedic.jpg"
                alt="Orthopaedics at MAMS Hospital"
                className="rounded-2xl shadow-2xl w-full"
              canonicalUrl="https://mamshospitals.com/departments/orthopaedics"
      />
            </div>
          </div>
        </div>
      </section>

      {/* SUB-SPECIALTIES */}
      <section className="py-16 md:py-20 px-0 bg-white">
        <div className="container mx-auto max-w-6xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Sub-Specialties in Orthopaedics
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Comprehensive orthopaedic care covering all aspects of bone, joint, and spine health.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {subspecialties.map((specialty, index) => (
              <Card key={index} className="overflow-hidden hover:shadow-lg transition-shadow duration-300 group">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={specialty.image}
                    alt={specialty.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>

                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{specialty.title}</h3>
                  <p className="text-gray-600">{specialty.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* TREATMENTS */}
      <section className="py-16 md:py-20 px-0 bg-gray-50">
        <div className="container mx-auto max-w-6xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Treatments & Procedures</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Advanced orthopaedic procedures for comprehensive bone and joint care.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {treatments.map((treatment, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-teal-100 flex items-center justify-center mt-1">
                    <Check className="w-4 h-4 text-teal-600" />
                  </div>
                  <span className="text-gray-700 font-medium">{treatment}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE */}
      <section className="py-16 md:py-20 px-0 bg-white">
        <div className="container mx-auto max-w-6xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Why Choose MAMS Hospitals for Orthopaedic Care
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Leading orthopaedic hospital near Miyapur & Bachupally with comprehensive care facilities.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {whyChoose.map((item, index) => (
              <Card key={index} className="text-center p-6 hover:shadow-lg transition-shadow duration-300">
                <CardContent className="p-6">
                  <div className="w-16 h-16 rounded-full bg-teal-100 flex items-center justify-center mx-auto mb-4">
                    <item.icon className="w-8 h-8 text-teal-600" />
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-gray-600">{item.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* SPECIALIST */}
                {doctors.length > 0 && (
          <section className="py-16 px-0 bg-apple-gray-50">
            <div className="container mx-auto max-w-6xl">
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">Meet Our Specialists</h2>
              </div>
              <div className="relative">
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: -340, behavior: 'smooth' }); }}
                  className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                </button>
                <div id="doc-scroll" className="flex gap-6 overflow-x-auto scroll-smooth px-10 scrollbar-hide pb-4">
                  {doctors.map(doctor => (
                    <div key={doctor.id} className="w-[280px] sm:w-[300px] flex-shrink-0">
                      <DoctorCard doctor={{
                        name: doctor.title.rendered,
                        slug: doctor.slug,
                        imageUrl: doctor._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "",
                        specialty: doctor._embedded?.["wp:term"]?.[0]?.[0]?.name || "",
                        designation: doctor.acf?.designation || "",
                        qualification: doctor.acf?.qualification || "",
                        experience: doctor.acf?.experience || "",
                      }} />
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: 340, behavior: 'smooth' }); }}
                  className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                </button>
              </div>
              <div className="text-center mt-8">
                <Link to="/doctors">
                  <button className="px-6 py-3 rounded-full border text-sm font-medium inline-flex items-center gap-2">
                    View All Doctors
                  </button>
                </Link>
              </div>
            </div>
          </section>
          )}

      {/* ARTICLES */}
      {/* <section className="py-16 md:py-20 px-0 bg-white">
        <div className="container mx-auto max-w-6xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Recent Articles</h2>
            <p className="text-lg text-gray-600">Expert insights on orthopaedic health and wellness</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {articles.map((article, index) => (
              <Card key={index} className="overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer">
                <CardContent className="p-6">
                  <span className="inline-block bg-teal-100 text-teal-700 text-xs font-semibold px-3 py-1 rounded-full mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-semibold text-gray-900 leading-snug">{article.title}</h3>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section> */}

      {/* FAQ */}
      <section className="py-16 md:py-20 px-0 bg-gray-50">
        <div className="container mx-auto max-w-4xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
            <p className="text-lg text-gray-600">Common questions about orthopaedic care at MAMS Hospitals</p>
          </div>

          <div className="bg-white rounded-2xl shadow-sm p-6">
            <Accordion type="single" collapsible>

              <AccordionItem value="item-1">
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-teal-600">
                  Do you perform knee and hip replacement surgeries?
                </AccordionTrigger>
                <AccordionContent className="text-gray-600">
                  Yes, we specialize in advanced joint replacement procedures with excellent recovery outcomes.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-2">
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-teal-600">
                  Is physiotherapy available at the hospital?
                </AccordionTrigger>
                <AccordionContent className="text-gray-600">
                  Yes, we have an in-house physiotherapy and rehabilitation center for post-surgery recovery.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-3">
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-teal-600">
                  Do you treat sports injuries?
                </AccordionTrigger>
                <AccordionContent className="text-gray-600">
                  Yes, we provide arthroscopy, ligament reconstruction, and complete sports injury management.
                </AccordionContent>
              </AccordionItem>

            </Accordion>
          </div>
        </div>
      </section>

      {/* Contact & Appointment Section */}
      <section className="py-16 px-0 bg-apple-teal text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold mb-4">Book an Appointment</h2>
            <p className="text-white/90 max-w-2xl mx-auto">
              Your heart health is our top priority. Book an appointment today with Hyderabad's trusted experts at MAMS Hospitals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Phone className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Call Us</h3>
                <a href="tel:+917399999981" className="text-white/90 hover:text-white">
                  +91-7399999981
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Mail className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Email Us</h3>
                <a href="mailto: info@mamshospitals.com" className="text-white/90 hover:text-white">
                   info@mamshospitals.com
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <MapPin className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Visit Us</h3>
                <p className="text-white/90">Bachupally, Miyapur</p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            {/* <Link href="/book-appointment">
              <Button size="lg" variant="secondary" className="rounded-full">
                <Calendar className="mr-2 h-5 w-5" />
                Schedule Your Appointment
              </Button>
            </Link> */}
          </div>
        </div>
      </section>

      {/* Emergency Banner */}
      <section className="py-8 px-0 bg-red-600 text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <Clock className="h-8 w-8" />
              <div>
                <h3 className="text-xl font-bold">24/7 Emergency Care</h3>
                <p className="text-white/90">Fully equipped emergency department </p>
              </div>
            </div>
            <a href="tel:+917399999981">
              <Button size="lg" variant="secondary" className="w-full sm:w-auto rounded-full bg-white text-red-600 hover:bg-gray-100">
                <Phone className="mr-2 h-5 w-5" />
                Call Emergency
              </Button>
            </a>
          </div>
        </div>
      </section>

    </div>
    </>
  );
}
